/**
 * NOVACART — Conversion Features JS
 * Sticky bar, countdown, popup, animations, gallery, BA slider
 */
(function () {
  'use strict';

  /* =============================================
     INTERSECTION OBSERVER — ANIMATE ON SCROLL
     ============================================= */
  function initAnimations() {
    var els = document.querySelectorAll('.nc-animate');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in-view');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* =============================================
     STICKY ADD TO CART BAR
     ============================================= */
  function initStickyBar() {
    var bar = document.querySelector('.nc-sticky-bar');
    var trigger = document.querySelector('.nc-lp-cta');
    if (!bar || !trigger) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('visible', !e.isIntersecting);
      });
    }, { threshold: 0 });

    observer.observe(trigger);

    var btn = bar.querySelector('.nc-sticky-bar__btn');
    if (btn) {
      btn.addEventListener('click', function () {
        var mainBtn = document.querySelector('.nc-lp-btn-buy, .nc-lp-btn-atc, [name="add"]');
        if (mainBtn) mainBtn.click();
      });
    }
  }

  /* =============================================
     FLOATING CART BADGE
     ============================================= */
  function initFloatCart() {
    var badge = document.querySelector('.nc-float-cart__count');
    if (!badge) return;

    function update(n) {
      if (n > 0) {
        badge.textContent = n;
        badge.classList.remove('hidden');
      } else {
        badge.classList.add('hidden');
      }
    }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { update(c.item_count); })
      .catch(function () {});

    document.addEventListener('cart:refresh', function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { update(c.item_count); });
    });
  }

  /* =============================================
     COUNTDOWN TIMER
     ============================================= */
  function initCountdown() {
    var timers = document.querySelectorAll('[data-nc-countdown]');
    timers.forEach(function (timer) {
      var endStr = timer.getAttribute('data-nc-countdown');
      var end;

      if (!isNaN(parseInt(endStr, 10))) {
        // minutes from now
        end = Date.now() + parseInt(endStr, 10) * 60 * 1000;
        // Persist so it doesn't reset on page reload
        var key = 'nc_cd_' + timer.id;
        var saved = localStorage.getItem(key);
        if (saved && parseInt(saved, 10) > Date.now()) {
          end = parseInt(saved, 10);
        } else {
          localStorage.setItem(key, end);
        }
      } else {
        end = new Date(endStr).getTime();
      }

      var hEl = timer.querySelector('[data-cd-h]');
      var mEl = timer.querySelector('[data-cd-m]');
      var sEl = timer.querySelector('[data-cd-s]');

      function tick() {
        var diff = Math.max(0, end - Date.now());
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');
        if (diff > 0) requestAnimationFrame(tick);
      }
      tick();
    });
  }

  /* =============================================
     BEFORE / AFTER SLIDER
     ============================================= */
  function initBASliders() {
    document.querySelectorAll('.nc-ba-slider').forEach(function (slider) {
      var handle = slider.querySelector('.nc-ba-slider__handle');
      var after  = slider.querySelector('.nc-ba-slider__after');
      if (!handle || !after) return;

      var dragging = false;

      function setPosition(x) {
        var rect = slider.getBoundingClientRect();
        var pct  = Math.max(0, Math.min(100, ((x - rect.left) / rect.width) * 100));
        handle.style.left = pct + '%';
        after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      }

      handle.addEventListener('mousedown',  function (e) { dragging = true; e.preventDefault(); });
      handle.addEventListener('touchstart', function (e) { dragging = true; e.preventDefault(); }, { passive: false });

      window.addEventListener('mousemove',  function (e) { if (dragging) setPosition(e.clientX); });
      window.addEventListener('touchmove',  function (e) { if (dragging) setPosition(e.touches[0].clientX); });
      window.addEventListener('mouseup',    function () { dragging = false; });
      window.addEventListener('touchend',   function () { dragging = false; });
    });
  }

  /* =============================================
     FAQ ACCORDION
     ============================================= */
  function initFAQ() {
    document.querySelectorAll('.nc-faq-item__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.nc-faq-item');
        var isOpen = item.classList.contains('nc-faq-item--open');

        document.querySelectorAll('.nc-faq-item--open').forEach(function (open) {
          open.classList.remove('nc-faq-item--open');
        });

        if (!isOpen) item.classList.add('nc-faq-item--open');
      });
    });
  }

  /* =============================================
     PRODUCT IMAGE GALLERY (LP)
     ============================================= */
  function initLPGallery() {
    document.querySelectorAll('.nc-lp-hero__gallery').forEach(function (gallery) {
      var mainImg  = gallery.querySelector('.nc-lp-hero__main img');
      var thumbs   = gallery.querySelectorAll('.nc-lp-hero__thumb');

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          var src = thumb.querySelector('img');
          if (src && mainImg) {
            mainImg.src = src.src;
            mainImg.srcset = src.srcset || '';
          }
          thumbs.forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
        });
      });

      if (thumbs[0]) thumbs[0].classList.add('active');
    });
  }

  /* =============================================
     QUANTITY SELECTOR
     ============================================= */
  function initQty() {
    document.querySelectorAll('.nc-qty').forEach(function (qtyEl) {
      var input = qtyEl.querySelector('.nc-qty__input');
      var dec   = qtyEl.querySelector('[data-qty-dec]');
      var inc   = qtyEl.querySelector('[data-qty-inc]');
      if (!input) return;

      if (dec) dec.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      if (inc) inc.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* =============================================
     RECENT ORDERS POPUP
     ============================================= */
  function initPopup() {
    var popup = document.querySelector('.nc-popup[data-popup="orders"]');
    if (!popup) return;

    var names   = (popup.dataset.names || 'Ahmed,Sara,Mohamed,Fatima,Karim,Leila,Youssef,Nadia').split(',');
    var cities  = (popup.dataset.cities || 'Casablanca,Rabat,Marrakech,Fès,Agadir,Tanger').split(',');
    var times   = (popup.dataset.times || '2,5,8,12,15,20,30').split(',');
    var product = popup.dataset.product || 'ce produit';

    var titleEl = popup.querySelector('.nc-popup__title');
    var subEl   = popup.querySelector('.nc-popup__subtitle');
    var closeBtn = popup.querySelector('.nc-popup__close');

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.classList.remove('show');
      });
    }

    function show() {
      var name = names[Math.floor(Math.random() * names.length)];
      var city = cities[Math.floor(Math.random() * cities.length)];
      var mins = times[Math.floor(Math.random() * times.length)];

      if (titleEl) titleEl.textContent = name + ' de ' + city;
      if (subEl)   subEl.textContent   = 'a commandé ' + product + ' il y a ' + mins + ' min';

      popup.classList.add('show');
      setTimeout(function () { popup.classList.remove('show'); }, 5000);
    }

    // Initial delay then repeat
    setTimeout(function () {
      show();
      setInterval(show, 18000);
    }, 8000);
  }

  /* =============================================
     VISITORS COUNTER
     ============================================= */
  function initVisitors() {
    document.querySelectorAll('[data-nc-visitors]').forEach(function (el) {
      var min = parseInt(el.dataset.min || '12', 10);
      var max = parseInt(el.dataset.max || '47', 10);
      var count = Math.floor(Math.random() * (max - min + 1)) + min;
      el.textContent = count;

      setInterval(function () {
        var delta = Math.random() > 0.5 ? 1 : -1;
        count = Math.max(min, Math.min(max, count + delta));
        el.textContent = count;
      }, 12000);
    });
  }

  /* =============================================
     INIT
     ============================================= */
  function init() {
    initAnimations();
    initStickyBar();
    initFloatCart();
    initCountdown();
    initBASliders();
    initFAQ();
    initLPGallery();
    initQty();
    initPopup();
    initVisitors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
